"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import createClasses from "./createClasses";
import dropdownFilterStore from "../stores/dropdownFilterStore";
import _ from "lodash";
import L from "../leaflet";
class FilterModalOverlay {
  constructor(parent) {
    this.parent = parent;
    this.closeOverlay = L.DomUtil.create(
      "span",
      createClasses("decidimGeo__modalOverlay", ["closed"]),
      this.parent
    );
    this.closeOverlay.onclick = _.debounce(this.handleOverlayClick.bind(this), 400, {
      leading: false
    });
  }
  toggleOpen() {
    dropdownFilterStore.setState(({ selectedFilters }) => ({
      nextFilters: __spreadValues({}, selectedFilters)
    }));
    dropdownFilterStore.getState().toggleOpen();
  }
  handleOverlayClick() {
    this.toggleOpen();
    this.repaint();
  }
  repaint() {
    const { isOpen } = dropdownFilterStore.getState();
    this.closeOverlay.className = createClasses("decidimGeo__modalOverlay", [
      isOpen ? "open" : "closed"
    ]);
  }
  onAdd(_map) {
    dropdownFilterStore.subscribe(
      (state) => [state.isOpen, state.selectedFilters],
      () => this.repaint()
    );
  }
}
export default FilterModalOverlay;
